import { initialState } from './state'
import { PayloadAction } from '@reduxjs/toolkit'
import { FilterMessageOption, Message, MessagesSliceState } from 'src/core/models'

const reducers = {
  /* Notifications Reducers */
  setMessagesListLoading: (state: MessagesSliceState, action: PayloadAction<boolean>) => {
    state.messages.loading = action.payload
  },
  setMessagesList: (state: MessagesSliceState, action: PayloadAction<Message[]>) => {
    state.messages.messages = action.payload
    state.messages.filteredMessages = action.payload
  },
  setMessagesFilterText: (state: MessagesSliceState, action: PayloadAction<string>) => {
    state.messages.filterText = action.payload
  },
  resetMessagesList: (state: MessagesSliceState) => {
    state.messages = initialState.messages
  },
  // eslint-disable-next-line max-len
  filterMessageByOption: (state: MessagesSliceState, action: PayloadAction<{ option: FilterMessageOption, userId: number }>) => {
    const oldMessages = state.messages.messages
    const { option, userId } = action.payload
    if (option === 'ALL') {
      state.messages.filteredMessages = state.messages.messages
      state.messages.filterText = ''
    } else if (option === 'SENT') {
      const newMessages = oldMessages.filter((m: Message) => m.receiver !== userId)
      state.messages.filteredMessages = newMessages
    } else if (option === 'INBOX') {
      const newMessages = oldMessages.filter((m: Message) => m.receiver === userId)
      state.messages.filteredMessages = newMessages
    } else if (option === 'NON_READ') {
      const newMessages = oldMessages.filter((m: Message) => !m.read)
      state.messages.filteredMessages = newMessages
    }
  },
  filterMessagesByText: (state: MessagesSliceState, action: PayloadAction<string>) => {
    const oldMessages = state.messages.messages
    const text = action.payload?.toLocaleLowerCase()
    if (text === undefined || text === null || text?.trim()?.length === 0) {
      state.messages.filteredMessages = oldMessages
    } else {
      const newMessages = oldMessages.filter((m: Message) => {
        return m.sender_name.toLowerCase().includes(text) ||
          m.receiver_name.toLowerCase().includes(text) ||
          m.sender_lastname.toLowerCase().includes(text) ||
          m.receiver_lastname.toLowerCase().includes(text) ||
          m.subject.toLowerCase().includes(text)
      })
      state.messages.filteredMessages = newMessages
    }
  },
  setMessagesCount: (state: MessagesSliceState, action: PayloadAction<number | null>) => {
    state.messages.count = action.payload
  },
  // Send Messages Reducers
  setSendMessageLoading: (state: MessagesSliceState, action: PayloadAction<boolean>) => {
    state.sendMessage.loading = action.payload
  },
  setSendMessageSuccess: (state: MessagesSliceState, action: PayloadAction<boolean>) => {
    state.sendMessage.success = action.payload
  },
  setSendMessageError: (state: MessagesSliceState, action: PayloadAction<any>) => {
    state.sendMessage.error = action.payload
  },
  resetSendMessage: (state: MessagesSliceState) => {
    state.sendMessage = initialState.sendMessage
  },
  addNewMessageSended: (state: MessagesSliceState, action: PayloadAction<Message>) => {
    const newMessages = [action.payload, ...state.messages.messages]
    state.messages.messages = newMessages
    state.messages.filteredMessages = newMessages
  },
  // Read message reducers
  setReadMessageLoading: (state: MessagesSliceState, action: PayloadAction<boolean>) => {
    state.readMessage.loading = action.payload
  },
  setReadMessageSuccess: (state: MessagesSliceState, action: PayloadAction<boolean>) => {
    state.readMessage.success = action.payload
  },
  setReadMessageCurrentId: (state: MessagesSliceState, action: PayloadAction<number>) => {
    state.readMessage.currentMessage = action.payload
  },
  resetReadMessage: (state: MessagesSliceState) => {
    state.readMessage = initialState.readMessage
  },
}

export default reducers
